import { Box, Button, FormControl, Grid, MenuItem, OutlinedInput, Select, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from "react";
import { useApiClient } from '../../context/ApiClientContext';
import toast from 'react-hot-toast';
import ComponentBackdrop from '../../components/backdrop';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../helper/baseApi';
import SuccessAlert from '../../helper/successAlert';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { Check } from '@mui/icons-material';
import UploadGridValueTags from './uploadGridValueTags';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const Form = ({ mode, onModeChange, onSuccess, teamId, teamDetails, memberList }) => {

  const labelWidth = 100;
  const { id: paramId } = useParams();
  const id = teamId || paramId;
  const [errors, setErrors] = useState({});
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const theme = useTheme();
  const [personName, setPersonName] = useState([]);

  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const navigate = useNavigate();
  const [valueTagList, setValueTagList] = useState([]);
  const [inputForm, setInputForm] = useState({
    id: "",
    name: "",
    code: "",
    startDate: "",
    endDate: "",
    isActive: "",
    teamMembers: [
      {
        teamMemberId: ""
      }
    ],
    valueTag: [
      {
        teamValueTagId: "",
        name: "",
        description: "",
        iconCode: "",
        passRate: "",
        isActive: ""
      }
    ]
  });

  useEffect(() => {
    if (mode === "edit" || mode === "view") {
      const team = teamDetails || {};
      setInputForm(
        {
          ...team,
          id: team.teamId
        });

        if (team.teamMembers) {
          setPersonName(team.teamMembers.map((member) => member.employeeId));
        } 
        
        if(team.teamValueTags) {
          setValueTagList(team.teamValueTags)
        }
    } else {
      setInputForm({
        name: "",
        code: "",
        startDate: "",
        endDate: "",
        isActive: "",
        teamMembers: [
          {
            teamMemberId: "",
            employeeId: "",
            code: "",
            fullName: "",
            isActive: "",
            memberJoinDate: ""
          }
        ],
        valueTag: [
          {
            teamValueTagId: "",
            name: "",
            description: "",
            iconCode: "",
            passRate: "",
            isActive: ""
          }
        ]
      });
    }
  }, [mode, teamDetails]);

  const changeEdit = () => {
    onModeChange("edit");
  };

  const submitForm = async () => {
    // reset errors
    let newErrors = {};

    if (!inputForm.name || inputForm.name.trim() === "") {
      newErrors.name = "Team name is required";
    }

    if (!inputForm.startDate || inputForm.startDate.trim() === "") {
      newErrors.startDate = "Start date is required";
    }

    if (!inputForm.endDate || inputForm.endDate.trim() === "") {
      newErrors.endDate = "End date is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // stop submit
    }

    try {
      setOpenBackdrop(true);

      let response = '';
      let apiUrl = '';

      const payload = { ...inputForm, valueTag: valueTagList, teamMembers: personName }

      console.log('members', personName);
      console.log('valueTagList', valueTagList);
      console.log('payload', payload);

      if (mode === 'edit') {
        apiUrl = `${mobileApiUrl}team/update-details`;
        response = await api.put(apiUrl, {
          ...inputForm,
          teamId: id,
          valueTag: valueTagList,
        });
      } else {
        apiUrl = `${mobileApiUrl}team/create-department`;
        response = await api.post(apiUrl, payload);
      }

      if (response.status == 200) {
        setTimeout(() => {
          if (mode == 'create') {
            onModeChange(false);
            onSuccess();
          } else {
            navigate("/team");
          }
          setOpenBackdrop(false);
          SuccessAlert(response.data.message);
        }, 2000);
      }
    } catch (error) {
      toast.error("Error fetching data:" + error.message);
      setOpenBackdrop(false);
    }
  };

  const SubmitButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={() => submitForm("Successfully created.")}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
          //   mb: 3,
        }}
      >
        Save
      </Button>
    </Box>
  );

  const EditButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={mode === "edit" ? submitForm : changeEdit}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
        }}
      >
        {mode === "edit" ? "Save" : "Edit"}
      </Button>
    </Box>
  );

  const handleInputChange = (id, e) => {
    setInputForm((prev) => ({
      ...prev,
      [id]: e.target.value,
    }));
  };

  const renderField = (label, id, type = "text", select = false, options = [], disabled = false) => (
    <Box>
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignItems: { sm: "center" },
        }}
      >
        {label}
      </Typography>
      <TextField
        id={id}
        type={type}
        select={select}
        multiple
        slotProps={{
          input: { readOnly: disabled }
        }}
        error={!!errors[id]}
        helperText={errors[id] || " "}
        onChange={(e) => handleInputChange(id, e)}
        value={inputForm[id] || []}
        required
        fullWidth
        size="small"
        variant="outlined"
        autoFocus={id === "name"}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                maxHeight: 200,
              },
            },
          },
        }}
      >
        {select &&
          options.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
              {opt.name}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );

  const renderYearField = (label, id, disabled = false) => (
    <Box >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignItems: { sm: "center" },
        }}
      >
        {label}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          views={["year"]}
          disabled={disabled}
          format="DD/MM/YYYY"
          value={inputForm[id] ? dayjs(inputForm[id]) : null}
          onChange={(newValue) => {
            if (newValue) {
              const year = newValue.year();
              setInputForm((prev) => ({
                ...prev,
                [id]: id === "startDate"
                  ? `${year}-01-01`
                  : `${year}-12-31`,
              }));
            }
          }}
          slotProps={{
            textField: {
              size: "medium", fullWidth: true, sx: {
                "& .MuiPickersSectionList-sectionContent": {
                  fontSize: "14px",
                  lineHeight: "1.2",
                },
              },
              fullWidth: true,
              size: "small",
              error: !!errors[id],
              helperText: errors[id],
              input: { readOnly: disabled }
            },
            popper: {
              placement: "bottom-end",
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
        {mode === "create" ? (
          <SubmitButton />
        ) : (
          <EditButton changeEdit={changeEdit} />
        )}
      </Box>

      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 4 }} width="100%">
        <Grid size={{ xs: 12, md: 6 }}>
          {renderField("Name", "name", "text", false, [], mode === "view")}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          {renderYearField("Start Year", "startDate", mode === "view")}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          {renderField("Code", "code", "text", false, [], mode === "view")}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          {renderYearField("End Year", "endDate", mode === "view")}
        </Grid>

        <Grid size={{ xs: 12 }} mb={3}>
          <Box
            sx={{
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
              }}
            >
              Members
            </Typography>

            <FormControl sx={{ width: "100%" }}>
              <Select
                fullWidth
                size="small"
                multiple
                displayEmpty
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  if (selected.length === 0) return <em>Select member(s)</em>;
                  const selectedNames = selected
                    .map((id) => {
                      const member = memberList.find((m) => m.id === id);
                      return member ? member.name : id;
                    })
                    .join(", ");

                  return selectedNames;
                }}
                MenuProps={MenuProps}
                inputProps={{ "aria-label": "Without label" }}
              >
                {memberList.map((members) => (
                  <MenuItem
                    key={members.id}
                    value={members.id}
                    style={getStyles(members.name, personName, theme)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <span>{members.name}</span>

                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="note" component="span" pl={2}>
                          {members.role || "User"}
                        </Typography>
                        <Box sx={{ pl: 1, display: "flex", justifyContent: "center", width: 20 }}>
                          {personName.includes(members.id) ? (
                            <Check fontSize="small" />
                          ) : (
                            <Box sx={{ width: 20 }} /> // empty space to reserve
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <UploadGridValueTags valueTags={valueTagList} onDataChange={(rows) => setValueTagList(rows)} />
        </Grid>
      </Grid>

      <ComponentBackdrop openBackdrop={openBackdrop} />
    </Box>
  )
}

export default Form;